import { isEmpty, get } from "lodash";
import EXTENSIONS from "@/constants/extensions";

export default {
    data() {
        return {
            isCubex: false
        };
    },
    methods: {
        isCubexItem(item) {
            // First check if Cubex extension is enabled
            if (!this._isExtensionEnabled(EXTENSIONS.CODE.CODE_CUBEX)) {
                return false;
            }

            // Handle empty/null cases
            if (isEmpty(item)) {
                return false;
            }

            // Check all possible Cubex indicators
            return (
                // Case 1: Item has dispensing reference
                get(item, "item_dispensing_references.length") > 0 &&
                get(item, "item_dispensing_references[0].source") ===
                    EXTENSIONS.CODE.CODE_CUBEX ||
                // Case 2: Item has been synced with Cubex
                Boolean(item.cubex_last_sync)
            );
        }
    }
};
